import { metaAdapter } from "@meta/index"
import { sortSizes } from "@src/core/utils";
import { isInStock } from "./utils";
import type { InitialConfig } from "@src/types"
import type {
  AnimaleBrandContext,
  AnimaleItemsContext,
  AnimaleValueContext,
  AnimaleBrandPDCContext,
  AnimaleItemsPDCContext,
  AnimaleValuePDCContext,
  AnimaleLineItemsContext,
  AnimaleLineItemsPDCContext,
  AnimaleAvailableGridContext,
  AnimaleLineItemsPDPContext,
  AnimaleItemsPDPContext,
} from "./types";

import { AnimalePdcZone } from './zones/PDC'
import { AnimalePdpZone } from './zones/PDP'


export const animaleAdapter = {
  ...metaAdapter, // global adapters

  brand: (context: AnimaleBrandContext, config: InitialConfig) => {
    if (context.zone === 'PDP') {
      return AnimalePdpZone.brand(context as AnimaleLineItemsPDPContext, config)
    }

    if (context.zone === 'PDC') {
      return AnimalePdcZone.brand(context as AnimaleBrandPDCContext, config)
    }

    return null
  },

  line_items: (context: AnimaleLineItemsContext): string | null => {
    if (context.zone === 'PDP') {
      return AnimalePdpZone.line_items(context as AnimaleLineItemsPDPContext)
    }

    if (context.zone === 'PDC') {
      return AnimalePdcZone.line_items(context as AnimaleLineItemsPDCContext)
    }

    return null
  },

  value: (context: AnimaleValueContext): number | null => {
    if (context.zone === 'PDP') {
      return AnimalePdpZone.value(context as AnimaleItemsPDPContext)
    }

    if (context.zone === 'PDC') {
      return AnimalePdcZone.value(context as AnimaleValuePDCContext)
    }

    return null;
  },

  items: (context: AnimaleItemsContext) => {
    if (context.zone === 'PDP') {
      return AnimalePdpZone.items(context as AnimaleItemsPDPContext)
    }

    if (context.zone === 'PDC') {
      return AnimalePdcZone.items(context as AnimaleItemsPDCContext)
    }
  },

  // param used only in one Zone, the PDP; no need condition
  available_grid: (context: AnimaleAvailableGridContext): string | null => {
    if (context?.available_grid) return context.available_grid

    if (context?.products) {
      // os SKUs da cor atual vêm em isVariantOf.hasVariant; o tamanho, em additionalProperty
      const sizes = context.products.flatMap((p) =>
        (p?.isVariantOf?.hasVariant ?? []).flatMap((variant) => {
          const available = variant?.offers?.offers?.some((o) => isInStock(o?.availability))
          const size = variant?.additionalProperty?.find((prop) => prop?.name === 'Tamanho')?.value

          return available && size ? [size] : []
        })
      )

      const result = sortSizes(sizes).join(',')
      return result || null
    }

    return null;
  },
}